// src/components/PasswordProtection.tsx
"use client";

import { ReactNode } from "react";

interface PasswordProtectionProps {
  children: ReactNode;
}

export function PasswordProtection({ children }: PasswordProtectionProps) {
  // For now, we'll just render the children
  // In the future, this can be used to protect certain routes
  return <>{children}</>;
}
